import {
    type SellScreenActionMode,
    type SellScreenActionTypes,
    type SellScreenSummaryMode,
} from "../../Actions/SellScreen/SellScreenActions";
import {
    SELL_SCREEN_ACTION_MODE_EMBEDDED,
    SELL_SCREEN_CHANGE_ACTION_MODE,
    SELL_SCREEN_CHANGE_SUMMARY_MODE,
    SELL_SCREEN_PREVIOUS_ACTION_MODE,
    SELL_SCREEN_PREVIOUS_SUMMARY_MODE,
} from "../../Actions/SellScreen/SellScreenConstants";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";
import { compare } from "../../Utilities/Generic/Objects";

export interface SellScreenModeState {
    action: SellScreenActionMode;
    summary: SellScreenSummaryMode;
    prevAction: SellScreenActionMode;
    prevSummary: SellScreenSummaryMode;
    actionOptions: Record<string, unknown>;
    prevActionOptions: Record<string, unknown>;
}

function SellScreenModeReducer(
    state: SellScreenModeState | undefined,
    action: ShopfrontActions<SellScreenActionTypes>
): SellScreenModeState {
    if(typeof state === "undefined") {
        return {
            action           : "keys",
            summary          : "transaction",
            prevAction       : "search",
            prevSummary      : "transaction",
            actionOptions    : {},
            prevActionOptions: {},
        };
    }

    switch(action.type) {
        case SELL_SCREEN_CHANGE_ACTION_MODE:
            // Check to see if the mode is already set
            if(action.mode === state.action) {
                if(action.mode !== SELL_SCREEN_ACTION_MODE_EMBEDDED) {
                    return state;
                } else if(!compare(action.options, state.actionOptions)) {
                    return state;
                }
            }

            return {
                ...state,
                action           : action.mode,
                prevAction       : state.action,
                actionOptions    : action.options,
                prevActionOptions: state.actionOptions,
            };
        case SELL_SCREEN_CHANGE_SUMMARY_MODE:
            return {
                ...state,
                summary    : action.mode,
                prevSummary: state.summary,
            };
        case SELL_SCREEN_PREVIOUS_ACTION_MODE:
            return {
                ...state,
                action       : state.prevAction,
                actionOptions: state.prevActionOptions,
            };
        case SELL_SCREEN_PREVIOUS_SUMMARY_MODE:
            return {
                ...state,
                summary: state.prevSummary,
            };
        default:
            return state;
    }
}

export default SellScreenModeReducer;
